var suuntoCountries = [
  {
    isCollapse: false,
    name: 'Asia / Pacific',
    locales: {
      en: { name: 'Asia / Pacific' },
      ja: { name: 'アジア太平洋地域' },
    },
    countries: [
      {
        country: {
          name: 'Australia',
          iso_code: 'AU',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-au/?setcountry=en-AU',
      },
      {
        country: {
          name: 'Hong Kong Area',
          iso_code: 'HK',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-hk/?setcountry=en-HK',
      },
      {
        country: {
          name: 'India',
          iso_code: 'in',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-in/?setcountry=en-IN',
      },
      {
        country: {
          name: 'Indonesia',
          iso_code: 'id',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-id/?setcountry=id-ID',
      },
      {
        country: {
          name: 'Malaysia',
          iso_code: 'my',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-my/?setcountry=en-MY',
      },
      {
        country: {
          name: 'New Zealand',
          iso_code: 'nz',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-nz/?setcountry=en-NZ',
      },
      {
        country: {
          name: 'Philippines',
          iso_code: 'ph',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-ph/?setcountry=en-PH',
      },
      {
        country: {
          name: 'Singapore',
          iso_code: 'sg',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-sg/?setcountry=en-SG',
      },
      {
        country: {
          name: 'Taiwan Area',
          iso_code: 'tw',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-tw/?setcountry=zh-TW',
      },
      {
        country: {
          name: 'Thailand',
          iso_code: 'th',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-th/?setcountry=th-TH',
      },
      {
        country: {
          name: 'Vietnam',
          iso_code: 'vn',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://apac.suunto.com/en-vn',
      },
      {
        country: {
          name: '대한민국',
          iso_code: 'KR',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: '한국어',
          iso_code: 'ko',
        },
        href: 'https://suunto.co.kr/',
      },
      {
        country: {
          name: '中国',
          iso_code: 'CN',
          currency: {
            iso_code: 'CN',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: '简体中文',
          iso_code: 'zh',
        },
        href: 'https://www.suunto.com/zh-chs/?setcountry=zh-CHS',
      },
      {
        country: {
          name: '日本',
          iso_code: 'jp',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: '日本語',
          iso_code: 'ja',
        },
        href: 'https://www.suunto.com/ja-jp/?setcountry=ja-JP',
      },
    ],
  },
  {
    isCollapse: false,
    name: 'Europe',
    locales: {
      en: { name: 'Europe' },
      ja: { name: 'ヨーロッパ' },
    },
    countries: [
      {
        country: {
          name: 'Albania',
          iso_code: 'AL',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/sq-al/?setcountry=sq-AL',
      },
      {
        country: {
          name: 'Andorra',
          iso_code: 'AD',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/ca-ad/?setcountry=ca-AD',
      },
      {
        country: {
          name: 'Belgique',
          iso_code: 'BE',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/fr-be/?setcountry=fr-BE',
      },
      {
        country: {
          name: 'Belgium',
          iso_code: 'BE',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-be/?setcountry=en-BE',
      },
      {
        country: {
          name: 'Bosnia & Herzegovina',
          iso_code: 'BA',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/bs-ba/?setcountry=bs-Cyrl-BA',
      },
      {
        country: {
          name: 'Croatia',
          iso_code: 'HR',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-hr/?setcountry=hr-HR',
      },
      {
        country: {
          name: 'Czech Republic',
          iso_code: 'CZ',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-cz/?setcountry=cs-CZ',
      },
      {
        country: {
          name: 'Denmark',
          iso_code: 'DK',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-dk/?setcountry=da-DK',
      },
      {
        country: {
          name: 'Deutschland',
          iso_code: 'DE',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Deutsch',
          iso_code: 'de',
        },
        href: 'https://www.suunto.com/de-de/?setcountry=de-DE',
      },
      {
        country: {
          name: 'España',
          iso_code: 'ES',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-es/?setcountry=es-ES',
      },
      {
        country: {
          name: 'Estonia',
          iso_code: 'EE',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-ee/?setcountry=et-EE',
      },
      {
        country: {
          name: 'Faroe Islands',
          iso_code: 'FO',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/fo-fo/?setcountry=fo-FO',
      },
      {
        country: {
          name: 'France',
          iso_code: 'FR',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/fr-fr/?setcountry=fr-FR',
      },
      {
        country: {
          name: 'Gibraltar',
          iso_code: 'GI',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-gi/?setcountry=en-GI',
      },
      {
        country: {
          name: 'Greece',
          iso_code: 'GR',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-gr/?setcountry=el-GR',
      },
      {
        country: {
          name: 'Guernsey',
          iso_code: 'GG',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-gg/?setcountry=en-GG',
      },
      {
        country: {
          name: 'Hungary',
          iso_code: 'HU',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-hu/?setcountry=hu-HU',
      },
      {
        country: {
          name: 'Iceland',
          iso_code: 'IS',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/is-is/?setcountry=is-IS',
      },
      {
        country: {
          name: 'Ireland',
          iso_code: 'IE',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-ie/?setcountry=en-IE',
      },
      {
        country: {
          name: 'Italia',
          iso_code: 'IT',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Italiano',
          iso_code: 'it',
        },
        href: 'https://www.suunto.com/it-it/?setcountry=it-IT',
      },
      {
        country: {
          name: 'Jersey',
          iso_code: 'JE',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-je/?setcountry=en-JE',
      },
      {
        country: {
          name: 'Liechtenstein',
          iso_code: 'LI',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/de-li/?setcountry=de-LI',
      },
      {
        country: {
          name: 'Luxembourg',
          iso_code: 'LU',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/fr-lu/?setcountry=fr-LU',
      },
      {
        country: {
          name: 'Malta',
          iso_code: 'MT',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/mt-mt/?setcountry=mt-MT',
      },
      {
        country: {
          name: 'Monaco',
          iso_code: 'MC',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/fr-mc/?setcountry=fr-MC',
      },
      {
        country: {
          name: 'Netherlands',
          iso_code: 'NL',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-nl/?setcountry=fy-NL',
      },
      {
        country: {
          name: 'Norway',
          iso_code: 'NO',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/nb-no/?setcountry=nb-NO',
      },
      {
        country: {
          name: 'Österreich',
          iso_code: 'AT',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Deutsch',
          iso_code: 'de',
        },
        href: 'https://www.suunto.com/de-at/?setcountry=de-AT',
      },
      {
        country: {
          name: 'Polska',
          iso_code: 'PL',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Polski',
          iso_code: 'pl',
        },
        href: 'https://www.suunto.com/pl-pl/?setcountry=pl-PL',
      },
      {
        country: {
          name: 'Portugal',
          iso_code: 'PT',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-pt/?setcountry=pt-PT',
      },
      {
        country: {
          name: 'San Marino',
          iso_code: 'SM',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Italiano',
          iso_code: 'it',
        },
        href: 'https://www.suunto.com/it-sm/?setcountry=it-SM',
      },
      {
        country: {
          name: 'Schweiz',
          iso_code: 'CH',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Deutsch',
          iso_code: 'de',
        },
        href: 'https://www.suunto.com/de-ch/?setcountry=de-CH',
      },
      {
        country: {
          name: 'Slovakia',
          iso_code: 'SK',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-sk/?setcountry=sk-SK',
      },
      {
        country: {
          name: 'Slovenia',
          iso_code: 'SI',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-si/?setcountry=sl-SI',
      },
      {
        country: {
          name: 'Suisse',
          iso_code: 'CH',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/fr-ch/?setcountry=fr-CH',
      },
      {
        country: {
          name: 'Suomi',
          iso_code: 'FI',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Suomi',
          iso_code: 'fi',
        },
        href: 'https://www.suunto.com/fi-fi/?setcountry=fi-FI',
      },
      {
        country: {
          name: 'Sverige',
          iso_code: 'SE',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Svenska',
          iso_code: 'sv',
        },
        href: 'https://www.suunto.com/sv-se/?setcountry=sv-SE',
      },
      {
        country: {
          name: 'United Kingdom',
          iso_code: 'GB',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-gb/?setcountry=en-GB',
      },
      {
        country: {
          name: 'Россия',
          iso_code: 'RU',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Русский',
          iso_code: 'ru',
        },
        href: 'https://www.suunto.com/ru-ru/?setcountry=ru-RU',
      },
    ],
  },
  {
    isCollapse: false,
    name: 'America',
    locales: {
      en: { name: 'America' },
      ja: { name: '南北アメリカ' },
    },
    countries: [
      {
        country: {
          name: 'Argentina',
          iso_code: 'AR',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-ar/?setcountry=es-AR',
      },
      {
        country: {
          name: 'Belize',
          iso_code: 'BZ',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-bz/?setcountry=en-BZ',
      },
      {
        country: {
          name: 'Bolivia',
          iso_code: 'BO',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-bo/?setcountry=es-BO',
      },
      {
        country: {
          name: 'Brazil',
          iso_code: 'BR',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/pt-br/?setcountry=pt-BR',
      },
      {
        country: {
          name: 'Canada',
          iso_code: 'CA',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-ca/?setcountry=en-CA',
      },
      {
        country: {
          name: 'Canada',
          iso_code: 'CA',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/fr-ca/?setcountry=fr-CA',
      },
      {
        country: {
          name: 'Chile',
          iso_code: 'CL',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-cl/?setcountry=es-CL',
      },
      {
        country: {
          name: 'Colombia',
          iso_code: 'CO',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-co/?setcountry=es-CO',
      },
      {
        country: {
          name: 'Costa Rica',
          iso_code: 'CR',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-cr/?setcountry=es-CR',
      },
      {
        country: {
          name: 'Dominican Republic',
          iso_code: 'DO',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-do/?setcountry=es-DO',
      },
      {
        country: {
          name: 'Ecuador',
          iso_code: 'EC',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/es-ec/?setcountry=es-EC',
      },
      {
        country: {
          name: 'Guadeloupe',
          iso_code: 'GP',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/fr-gp/?setcountry=fr-GP',
      },
      {
        country: {
          name: 'Guatemala',
          iso_code: 'GT',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-gt/?setcountry=es-GT',
      },
      {
        country: {
          name: 'Guyanne',
          iso_code: 'GF',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/fr-gf/?setcountry=fr-GF',
      },
      {
        country: {
          name: 'Honduras',
          iso_code: 'HN',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-hn/?setcountry=es-HN',
      },
      {
        country: {
          name: 'Jamaica',
          iso_code: 'JM',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-jm/?setcountry=en-JM',
      },
      {
        country: {
          name: 'Martinique',
          iso_code: 'MQ',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/fr-mq/?setcountry=fr-MQ',
      },
      {
        country: {
          name: 'Mexico',
          iso_code: 'MX',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-mx/?setcountry=es-MX',
      },
      {
        country: {
          name: 'Panama',
          iso_code: 'PA',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-pa/?setcountry=es-PA',
      },
      {
        country: {
          name: 'Paraguay',
          iso_code: 'PY',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-py/?setcountry=es-PY',
      },
      {
        country: {
          name: 'Peru',
          iso_code: 'PE',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-pe/?setcountry=es-PE',
      },
      {
        country: {
          name: 'United States',
          iso_code: 'US',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-us/?setcountry=en-US',
      },
      {
        country: {
          name: 'Uruguay',
          iso_code: 'UY',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-uy/?setcountry=es-UY',
      },
      {
        country: {
          name: 'Venezuela',
          iso_code: 'VE',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Español',
          iso_code: 'es',
        },
        href: 'https://www.suunto.com/es-ve/?setcountry=es-VE',
      },
    ],
  },
  {
    isCollapse: false,
    name: 'Africa / Middle East',
    locales: {
      en: { name: 'Africa / Middle East' },
      ja: { name: 'アフリカ & 中東' },
    },
    countries: [
      {
        country: {
          name: 'Algeria',
          iso_code: 'DZ',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/ar-dz/?setcountry=ar-DZ',
      },
      {
        country: {
          name: 'Egypt',
          iso_code: 'eg',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/ar-eg/?setcountry=ar-EG',
      },
      {
        country: {
          name: 'La Réunion',
          iso_code: 'RE',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/fr-re/?setcountry=fr-RE',
      },
      {
        country: {
          name: 'Lebanon',
          iso_code: 'LB',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/ar-lb/?setcountry=ar-LB',
      },
      {
        country: {
          name: 'Morocco',
          iso_code: 'MA',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/fr-ma/?setcountry=fr-MA',
      },
      {
        country: {
          name: 'South Africa',
          iso_code: 'ZA',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: 'en',
        },
        href: 'https://www.suunto.com/en-za/?setcountry=en-ZA',
      },
      {
        country: {
          name: 'Tunisia',
          iso_code: 'TN',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'Français',
          iso_code: 'fr',
        },
        href: 'https://www.suunto.com/ar-tn/?setcountry=ar-TN',
      },
    ],
  },
  {
    isCollapse: false,
    name: 'Your country or region is not listed here? ',
    locales: {
      en: { name: 'Your country or region is not listed here? ' },
      ja: { name: 'Your country or region is not listed here? ' },
    },
    countries: [
      {
        country: {
          name: 'Global Website',
          iso_code: '',
          currency: {
            iso_code: '',
            symbol: '',
          },
        },
        language: {
          useEndonym_name: true,
          endonym_name: 'English',
          iso_code: '',
        },
        href: 'https://www.suunto.com/',
      },
    ],
  },
];
